import "./ShippingReturns.module.css";
import Header from "@/reusable_sections/Header";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
export default function ShippingReturnsPage() {
  return <div>
      <Header />
      <Faq />
      <Footer />
    </div>;
}